import { render, staticRenderFns } from "./activities-compliance-card.vue?vue&type=template&id=715a5032&scoped=true&"
import script from "./activities-compliance-card.vue?vue&type=script&lang=js&"
export * from "./activities-compliance-card.vue?vue&type=script&lang=js&"
import style0 from "./activities-compliance-card.vue?vue&type=style&index=0&id=715a5032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715a5032",
  null
  
)

component.options.__file = "activities-compliance-card.vue"
export default component.exports